export const watch = {
  toggle() {
    if (this.toggle == false) {
      this.refresh()
      this.toggle = false
      if (this.Modal && this.Modal != undefined) {
        this.Modal.$emit('update:toggle', (this.toggle = false))
      }
    }
  },
  hoaId() {
    this.refresh()
  }
}
